/* App.jsx */
import React, {useEffect, useRef} from 'react'
// Components
import Home from './Pages/Home'
import Detail from './Pages/Detail'
// Router
import {Routes, Route} from 'react-router-dom'
// Audio
import BGM from './audio/bgm.mp3'
// CSS
import styled from 'styled-components'

function App() {
  // 오디오 DOM 에 접근
  const audioRef = useRef();

  useEffect(()=>{
    // 시작하자마자 실행되게
    audioRef.current.play(); 
  })
return (
    <>
    {/* 오디오는 그냥 전체에서 플레이 되게 여기서 만듬 */}
    <Audio src={BGM} controls loop ref={audioRef}></Audio>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/detail" element={<Detail/>}/>
      </Routes>
    </>
  );
}

export default App;

const Audio = styled.audio`
  position:absolute;
  top:100px;
  right:400px;
  width: 100px;
  padding: 0;
  color: white;
  &::-webkit-media-controls-enclosure {
    border-radius: 5px;
    padding: 0;
  }
  &::-webkit-media-controls-timeline-container,
  &::-webkit-media-controls-current-time-display,
  &::-webkit-media-controls-time-remaining-display,
  &::-webkit-media-controls-timeline,
  &::-webkit-media-controls-toggle-closed-captions-button{
    display: none;
  }
  
  @media screen and (max-width: 1600px) {
    display: none
  }
`;
